import { useState } from "react";
import { KeyRound, ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useTerminal } from "@/lib/terminal";
import { errMsg } from "@/lib/api";

export const BulkAddCard = ({ onSaved }) => {
  const { api } = useTerminal();
  const [keys, setKeys] = useState("");
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      const r = await api("post", "/wallets/bulk", { keys });
      setKeys("");
      toast.success(`${r.added.length} cüzdan eklendi`, {
        description: [r.skipped.length && `${r.skipped.length} zaten ekli`, r.invalid.length && `Geçersiz: ${r.invalid.join(", ")}`].filter(Boolean).join(" · ") || undefined,
      });
      onSaved();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setSaving(false); }
  };
  return (
    <div className="p-4 rounded-md border border-[#222634] bg-[#101216] space-y-3">
      <h2 className="text-sm font-semibold flex items-center gap-2"><KeyRound className="w-4 h-4 text-[#FFD700]" />Toplu Cüzdan Ekle</h2>
      <textarea data-testid="bulk-wallet-keys-input" value={keys} onChange={(e) => setKeys(e.target.value)} rows={5} spellCheck={false} autoComplete="off"
        placeholder={"Her satıra bir private key\nİsim vermek için:  Ana: 0xabc...\n0xdef..."}
        className="w-full p-3 rounded border border-[#222634] bg-[#161920] font-mono text-xs outline-none focus:border-[#333A4E] resize-y [-webkit-text-security:disc]" />
      <button data-testid="bulk-wallet-save-button" disabled={!keys.trim() || saving} onClick={save}
        className="w-full h-10 rounded bg-[#00E676] hover:bg-[#00C853] text-[#08090C] font-bold transition-colors disabled:opacity-40 flex items-center justify-center gap-2">
        {saving && <Loader2 className="w-4 h-4 animate-spin" />}Şifreleyip Ekle
      </button>
      <p className="text-[11px] text-slate-500 flex gap-1.5"><ShieldCheck className="w-3.5 h-3.5 shrink-0 text-[#00E676]" />Anahtarlar sunucuda şifreli saklanır, asla geri gösterilmez. Yeni cüzdanlar Trade ve Bot için otomatik seçilir.</p>
    </div>
  );
};
